export default  {
    "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
    "title": "Harlequins Membership 2019/20",
    "shortTitle": "",
    "description": "",
    "width": 1000,
    "height": 800,
    "currentLanguage": "",
    "languages": [],
    // "basePath": "",
    "basePath": "/membership2019",
    "companyLogo": "quins-logo.png",
    "publishURL": "http://quins.pblsh.media/static/_thumbs",
    "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
    "options": {
      "doublePage": false,
      "rightToLeft": false,
      "searchEnabled": false,
      "downloadEnabled": false,
      "downloadPath": '',
      "printEnabled": false,
      "zoomEnabled": true,
      "contentsEnabled": true,
      "languagesEnabled": false,
      "mobileSwitch": false,
      "guideEnabled": false,
      "galleryCaptions": {}
    },
    "pages": [[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 0,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg1.jpg",
      "zoom": null,
      "content": `
      <img id="p1-title" class="halfScale" style="top:35px; left:152px" src="/membership2019/static/_content/cover-t1.png">
      <img id="p1-title-2" class="halfScale" style="top:73px; left:82px" src="/membership2019/static/_content/cover-t2.png">
      <img id="p1-play" class="halfScale" style="top:275px; left:0px" src="/membership2019/static/_content/cover-players.png">
      <img id="p1-logo" class="halfScale" style="top:680px; left:67px" src="/membership2019/static/_content/p1-logos.png">
      `,
      "script": `
      function onPageEnter() {
        pg1Anim = new TimelineMax();
        pg1Anim.fromTo(idOf("p1-title"), 0.6, {opacity:0, x:-60}, {opacity:1, x:0, ease: Power2.easeOut}, 1 )
          .fromTo(idOf("p1-title-2"), 0.6, {opacity:0, y:-60}, {opacity:1, y:0, ease: Power2.easeOut}, "-=0.3")
      }

        function onPageLeave() {
          
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 1,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg2.jpg",
      "zoom": null,
      "content": `

      <img id="p2-title" class="halfScale" style="top:33px; left:38px" src="/membership2019/static/_content/p2-title.png">
      <img id="p2-quote" class="halfScaleC" style="top:590px; left:260px" src="/membership2019/static/_content/p2-quote.png">

      <div id="p2-sign" class="abs noOverflow" style="top:524px;left:354px;height:133px;width:153px">
          <img class="halfScale" src="/membership2019/static/_content/p2-sign.png">
      </div>
      
      `,
      "script": `
      function onPageEnter() {
        pg2Anim = new TimelineMax();
        pg2Anim.fromTo(idOf("p2-title"), 0.6, {opacity:0, x:-60}, {opacity:1, x:0, ease: Power2.easeOut}, 1 )
        .fromTo(idOf("p2-sign"), 0.6, {width:"0px"}, {width:"153px", ease: Power2.easeOut}, "-=0.4")
        .fromTo(idOf("p2-quote"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.4)}, "-=0.3" )
      }

        function onPageLeave() {
          pg2Anim.stop();
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 2,
      "subIndex": 0,
      "startIndex": 0,
      "original": "campaign-page.jpg",
      "zoom": null,
      "content": `

      <img id="campaign-title" class="halfScale" style="top:33px; left:38px" src="/membership2019/static/_content/campaign-title.png">

      <a onclick="Publish.openVideo('https://www.youtube.com/embed/sVDR-ug44wE')">
      <img id="campaign-image" class="halfScale" style="top:247px; left:137px" src="/membership2019/static/_content/campaign-image.png">
      </a>
      
      `,
      "script": `
      function onPageEnter() {
        pg2Anim = new TimelineMax();
        pg2Anim.fromTo(idOf("campaign-title"), 0.6, {opacity:0, x:-60}, {opacity:1, x:0, ease: Power2.easeOut}, 1 )
        
      }

        function onPageLeave() {
          pg2Anim.stop();
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 3,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg4.jpg",
      "zoom": null,
      "content": `
      
      <img id="p4-title" class="halfScale p4-title" style="top:53px; left:32px" src="/membership2019/static/_content/p4-title.png">
      <img id="p4-sub" class="halfScale p4-sub" style="top:377px; left:33px" src="/membership2019/static/_content/p4-sub-1.png">
      <img id="p4-sub" class="halfScale p4-sub" style="top:559px; left:34px" src="/membership2019/static/_content/p4-sub-2.png">
      <img id="p4-sub" class="halfScale p4-sub" style="top:378px; left:446px" src="/membership2019/static/_content/p4-sub-3.png">
      <img id="p4-sub" class="halfScale p4-sub" style="top:557px; left:446px" src="/membership2019/static/_content/p4-sub-4.png">
      <img id="p4-sub" class="halfScale p4-sub" style="top:708px; left:32px" src="/membership2019/static/_content/p4-btn.png">

      <a href="https://hospitality.quins.co.uk/single-match/1866-lounge/" target="_blank">
        <div class="addContentLink" style="top:513px;left:114px;width:80px;height:20px;"></div>
      </a>

      <div class="contentLinkNone pointer" style="top: 709px; left: 32px; width: 280px; height: 49px;" onclick="showOverlay('theMatrix');"></div>
      <div class="contentLinkNone pointer" style="top: 512px; left: 114px; width: 80px; height: 21px;" onclick="showOverlay('theMatrix');"></div>

      <div id="theMatrix" class="standardTransition contentOverlay hidden noclick">
          <img class="halfScale" style="top:0px;left:246px;" src="/membership2019/static/_content/matrix.jpg">
          <img class="halfScale pointer" style="top:40px;left:950px" onclick="hideOverlay('theMatrix')" src="/membership2019/static/_content/p5-cross.png">
      </div>
      

      `,
      "script": `
      function onPageEnter() {
        pg4Anim = new TimelineMax();
        pg4Anim.staggerFromTo(cOf("p4-title"), 0.6, {opacity:0, x:-60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.3, 1)
          .staggerFromTo(cOf("p4-sub"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.3, "-=0.3")
        }

        function onPageLeave() {
          pg4Anim.stop();
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 4,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg5.jpg",
      "zoom": null,
      "content": `
      <img id="p5-title" class="halfScale" style="top:30px; left:28px" src="/membership2019/static/_content/p5-title-1.png">
      
      <a onclick="Publish.openVideo('https://www.youtube.com/embed/Ik0ksY0uPJI')">
        <img class="halfScaleC pointer pulse animatedpulse" style="top:720px; left:144px" src="/membership2019/static/_content/p5-play-sm.png">
      </a>
      <a onclick="Publish.openVideo('https://www.youtube.com/embed/mxZmkwIWZ30')">
        <img class="halfScaleC pointer pulse animatedpulse" style="top:720px; left:564px" src="/membership2019/static/_content/p5-play-sm.png">
      </a>
      
      <a onclick="Publish.openVideo('https://www.youtube.com/embed/JnjHrt4qGMQ')">
        <img id="" class="halfScaleC pointer pulse animatedpulse p5-icon" style="top:516px; left:212px" src="/membership2019/static/_content/p5-play-button.png">
      </a>
      <a onclick="Publish.openVideo('https://www.youtube.com/embed/IW2wgOAgKbE')">
        <img id="" class="halfScaleC pointer pulse animatedpulse p5-icon" style="top:516px; left:639px" src="/membership2019/static/_content/p5-play-button.png">
      </a>

      `,
      "script": `
      function onPageEnter() {
        pg5Anim = new TimelineMax();
        pg5Anim.fromTo(idOf("p5-title"), 0.6, {opacity:0, x:-60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.5 )
      }

        function onPageLeave() {
          pg5Anim.stop();
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 5,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg6a.jpg",
      "zoom": null,
      "content": `

      <audio controls id="dylan" style="opacity:0">
        <source src="/membership2019/static/_content/dylan.m4a" type="audio/mp4">
        Your browser does not support the audio tag.
      </audio>

      <audio controls id="gang" style="opacity:0">
        <source src="/membership2019/static/_content/gang.m4a" type="audio/mp4">
        Your browser does not support the audio tag.
      </audio>
      
      <img id="" class="halfScale p6-title" style="top:45px; left:35px" src="/membership2019/static/_content/p6-t1.png">
      <img id="" class="halfScale p6-title" style="top:150px; left:35px" src="/membership2019/static/_content/p6-t2.png">

      <img id="p6-box" class="halfScale" style="top:380px; left:0px" src="/membership2019/static/_content/p6-box.png">

      <img id="p6-photo" class="halfScale" style="top:312px; left:432px" src="/membership2019/static/_content/p6-photo.png">
      <img id="p6-boy" class="halfScale" style="top:380px; left:0px" src="/membership2019/static/_content/p6boy.png">
      <img id="p6-boxtext" class="halfScale" style="top:400px; left:21px" src="/membership2019/static/_content/p6-boxtext.png">

      <img id="p6-bears" class="halfScale" style="top:451px; left:520px" src="/membership2019/static/_content/p6-bears.png">

      <img id="p6-cam" class="halfScale pointer pulse" style="top:694px; left:661px" src="/membership2019/static/_content/p10-cam.png">
      <a onclick="Publish.openVideo('https://www.youtube.com/embed/8qFriHBv0ZY')">
        <img id="p6-cam" class="pointer pulse animatedpulse " style="top:702px; left:671px" src="/membership2019/static/_content/p10-play.png">
      </a>

      <img id="p6-bears" class="halfScale" style="top:662px; left:423px" src="/membership2019/static/_content/p6-btmtext.png">

      <img id="" class="halfScaleC pointer pulse animatedpulse p6-icon" onclick="showOverlay('p6-pop')" style="top:257px; left:438px" src="/membership2019/static/_content/quote-marks.png">
      <img id="" class="halfScaleC pointer pulse animatedpulse p6-icon" style="top:257px; left:622px;display:none" onclick="playGang()" src="/membership2019/static/_content/speaker.png">
      <img id="" class="halfScaleC pointer pulse animatedpulse p6-icon" style="top:257px; left:807px;display:none" onclick="playDylan()" src="/membership2019/static/_content/speaker.png">

      <div id="p6-pop" class="standardTransition contentOverlay hidden noclick">
          <img class="halfScale" style="top:0px;left:0px" src="/membership2019/static/_content/p6-pop-1.png">
          <img class="halfScale pointer" style="top:242px;left:720px" src="/membership2019/static/_content/cross.png" onclick="hideOverlay('p6-pop')">
      </div>
      
      `,
      "script": `
        function onPageEnter() {
          pg6Anim = new TimelineMax();
          pg6Anim.staggerFromTo(cOf("p6-title"), 0.6, {opacity:0, x:-60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.5, 1)
          .fromTo(idOf("p6-box"), 0.6, {opacity:0, x:-60}, {opacity:1, x:0, ease: Power2.easeOut}, "-=0.3")
          .fromTo(idOf("p6-boxtext"), 0.6, {opacity:0, x:-60}, {opacity:1, x:0, ease: Power2.easeOut}, "-=0.6")
          .fromTo(idOf("p6-photo"), 0.6, {opacity:0, y:-60}, {opacity:1, y:0, ease: Power2.easeOut}, "-=0.3")
          .staggerFromTo(cOf("p6-icon"), 0.6, {opacity:0}, {opacity:1, ease: Power2.easeOut}, "-=0.3", "-=0.3")
        }

        function playGang(){
          gang = document.getElementById("gang");
          dylan.pause();
          dylan.currentTime = 10;
          gang.currentTime = 1.3;
          setTimeout(function() {
            gang.play();
          }, 500)
          
        }

        function playDylan(){
          dylan = document.getElementById("dylan");
          gang.pause();
          gang.currentTime = 1.3;
          dylan.currentTime = 10;
          setTimeout(function() {
            dylan.play();
          }, 500)
        }

        function onPageLeave() {
          pg6Anim.stop();
          idOf('p6-pop').className = "standardTransition contentOverlay hidden noclick"
          dylan.pause();
          gang.pause();
        }

      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 6,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg7.jpg",
      "zoom": null,
      "content": `
      <img id="p7-title" class="halfScale" style="top:25px; left:20px" src="/membership2019/static/_content/p7-title-1.png">

      <img id="p7-sub" class="halfScale" style="top:136px; left:30px" src="/membership2019/static/_content/p7-sub-1.png">

      <img class="halfScaleC p7-vid" style="top:138px; left:-70px" src="/membership2019/static/_content/p7-vid-img-1.png">
      <img class="halfScale p7-text" style="top:323px; left:30px" src="/membership2019/static/_content/p7-sub-2.png">

      <img class="halfScaleC p7-vid" style="top:138px; left:155px" src="/membership2019/static/_content/p7-vid-img-2.png">
      <img class="halfScale p7-text" style="top:323px; left:255px" src="/membership2019/static/_content/p7-sub-3.png">

      <img class="halfScaleC p7-vid" style="top:322px; left:-70px" src="/membership2019/static/_content/p7-vid-img-3.png">
      <img class="halfScale p7-text" style="top:505px; left:30px" src="/membership2019/static/_content/p7-sub-4.png">

      <img class="halfScaleC p7-vid" style="top:322px; left:155px" src="/membership2019/static/_content/p7-vid-img-4.png">
      <img class="halfScale p7-text" style="top:505px; left:255px" src="/membership2019/static/_content/p7-sub-5.png">

      <img class="halfScaleC p7-vid" style="top:506px; left:-70px" src="/membership2019/static/_content/p7-vid-img-5.png">
      <img class="halfScale p7-text" style="top:692px; left:30px" src="/membership2019/static/_content/p7-sub-6.png">

      <img class="halfScaleC p7-vid" style="top:506px; left:155px" src="/membership2019/static/_content/p7-vid-img-6.png">
      <img class="halfScale p7-text" style="top:692px; left:255px" src="/membership2019/static/_content/p7-sub-7.png">

      <a onclick="Publish.openVideo('https://www.youtube.com/embed/XW0mgMW8Xoc')">
        <img id="" class="halfScaleC pointer pulse animatedpulse p7-play" style="top:236px; left:111px" src="/membership2019/static/_content/p7-play-button.png">
      </a>
      <a onclick="Publish.openVideo('https://www.youtube.com/embed/AY9qA5wYZO0')">
        <img id="" class="halfScaleC pointer pulse animatedpulse p7-play" style="top:236px; left:340px" src="/membership2019/static/_content/p7-play-button.png">
      </a>
      <a onclick="Publish.openVideo('https://www.youtube.com/embed/JFEv9mER5bk')">
        <img id="" class="halfScaleC pointer pulse animatedpulse p7-play" style="top:421px; left:111px" src="/membership2019/static/_content/p7-play-button.png">
      </a>
      <a onclick="Publish.openVideo('https://www.youtube.com/embed/pDvUVD5B6EE')">
        <img id="" class="halfScaleC pointer pulse animatedpulse p7-play" style="top:421px; left:340px" src="/membership2019/static/_content/p7-play-button.png">
      </a>
      <a onclick="Publish.openVideo('https://www.youtube.com/embed/GZ8UFXvfU30')">
        <img id="" class="halfScaleC pointer pulse animatedpulse p7-play" style="top:605px; left:111px" src="/membership2019/static/_content/p7-play-button.png">
      </a>
      <a onclick="Publish.openVideo('https://www.youtube.com/embed/wVFraWkxLIo')">
        <img id="" class="halfScaleC pointer pulse animatedpulse p7-play" style="top:605px; left:340px" src="/membership2019/static/_content/p7-play-button.png">
      </a>


      `,
      "script": `
        function onPageEnter() {
          pg7Anim = new TimelineMax();
          pg7Anim.fromTo(idOf("p7-title"), 0.6, {opacity:0, x:-60}, {opacity:1, x:0, ease: Power2.easeOut}, 1 )
          .fromTo(idOf("p7-sub"), 0.6, {opacity:0, x:-60}, {opacity:1, x:0, ease: Power2.easeOut}, "-=0.3" )
          .staggerFromTo(cOf("p7-vid"), 0.6, {opacity:0}, {opacity:1, ease: Power2.easeOut}, 0.3, "-=0.3" )
          .staggerFromTo(cOf("p7-play"), 0.6, {opacity:0}, {opacity:1, ease: Power2.easeOut}, 0.3, 2)
          .staggerFromTo(cOf("p7-text"), 0.6, {opacity:0, x:-60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.3, "-=0.3" )
        }

        function onPageLeave() {
          pg7Anim.stop();
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 7,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg8.jpg",
      "zoom": null,
      "content": `

      <img id="p8-title" class="halfScale p8-title" style="top:33px; left:38px" src="/membership2019/static/_content/p8-t1.png">
      <img id="p8-title" class="halfScale p8-title" style="top:131px; left:38px" src="/membership2019/static/_content/p8-t2.png">
      <img id="" class="halfScale" style="top:45px; left:376px" src="/membership2019/static/_content/p8-people.png">

      <img id="p8-sub" class="halfScale p8-title" style="top:586px; left:38px" src="/membership2019/static/_content/p8-sub-1.png">
      <img id="p8-sub" class="halfScale p8-title" style="top:641px; left:38px" src="/membership2019/static/_content/p8-sub-2.png">
      <img id="p8-sub" class="halfScale p8-title" style="top:716px; left:38px" src="/membership2019/static/_content/p8-sub-3.png">

      <div class="contentLinkNone pointer" style="top: 581px; left: 35px; width: 282px; height: 51px;" onclick="showOverlay('p8-pop-1');"></div>
      <div class="contentLinkNone pointer" style="top: 641px; left: 38px; width: 282px; height: 66px;" onclick="showOverlay('p8-pop-2');"></div>
      <div class="contentLinkNone pointer" style="top: 716px; left: 35px; width: 282px; height: 51px;" onclick="showOverlay('p8-pop-3');"></div>

      <div id="p8-pop-1" class="standardTransition contentOverlay hidden noclick">
          <img class="halfScale" style="top:0px;left:0px" src="/membership2019/static/_content/p8-pop-1.png">
          <img class="halfScale pointer" style="top:172px;left:850px" onclick="hideOverlay('p8-pop-1')" src="/membership2019/static/_content/p8-cross.png">
      </div>
      <div id="p8-pop-2" class="standardTransition contentOverlay hidden noclick">
          <img class="halfScale" style="top:0px;left:0px" src="/membership2019/static/_content/p8-pop-2.png">
          <img class="halfScale pointer" style="top:222px;left:850px" onclick="hideOverlay('p8-pop-2')" src="/membership2019/static/_content/p8-cross.png">
      </div>
      <div id="p8-pop-3" class="standardTransition contentOverlay hidden noclick">
          <img class="halfScale" style="top:0px;left:0px" src="/membership2019/static/_content/p8-pop-3.png">
          <img class="halfScale pointer" style="top:232px;left:730px" onclick="hideOverlay('p8-pop-3')" src="/membership2019/static/_content/p8-cross.png">
      </div>
      `,
      "script": `
        function onPageEnter() {
          pg8Anim = new TimelineMax();
          pg8Anim.staggerFromTo(cOf("p8-title"), 0.6, {opacity:0, x:-60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.3, 1)
          .staggerFromTo(cOf("p8-sub"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.3, "-=0.3")
        }

        function onPageLeave() {
          pg8Anim.stop();
          idOf('p8-pop-1').className = "standardTransition contentOverlay hidden noclick";
          idOf('p8-pop-2').className = "standardTransition contentOverlay hidden noclick";
          idOf('p8-pop-3').className = "standardTransition contentOverlay hidden noclick";
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 8,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg9.jpg",
      "zoom": null,
      "content": `
      
      <img id="p9-title" class="halfScale p9-title" style="top:33px; left:38px" src="/membership2019/static/_content/p9-title.png">

      <img id="p9-img-1" class="halfScaleC p9-img" style="top:135px; left:-192px" src="/membership2019/static/_content/p9-img-1.jpg">
      <img id="p9-img-2" class="halfScaleC p9-img" style="top:135px; left:283px" src="/membership2019/static/_content/p9-img-2.jpg">

      <img class="halfScale p9-sub" style="top:553px; left:202px" src="/membership2019/static/_content/p9-sub-1.png">
      <img class="halfScale p9-sub" style="top:553px; left:668px" src="/membership2019/static/_content/p9-sub-2.png">
      
      <a onclick="Publish.openVideo('https://www.youtube.com/embed/O0uMC-N-Ph8')">
        <img id="" class="halfScaleC pointer pulse animatedpulse p9-play" style="top:373px; left:256px" src="/membership2019/static/_content/p4-play-button.png">
      </a>
      <a onclick="Publish.openVideo('https://www.youtube.com/embed/b6rSQsTj75g')">
        <img id="" class="halfScaleC pointer pulse animatedpulse p9-play" style="top:373px; left:728px" src="/membership2019/static/_content/p4-play-button.png">
      </a>

      <div id="p9-hash" class="abs noOverflow" style="top:652px;left:387px;height:133px;width:293px">
          <img class="halfScale" src="/membership2019/static/_content/p9-hash.png">
        </div>
      `,
      "script": `
        function onPageEnter() {
          pg9Anim = new TimelineMax();
          pg9Anim.fromTo(idOf("p9-title"), 0.6, {opacity:0, x:-60}, {opacity:1, x:0, ease: Power2.easeOut}, 1)
          .staggerFromTo(cOf("p9-img"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.4)}, 0.1, "-=0.3" )
          .staggerFromTo(cOf("p9-play"), 0.6, {opacity:0}, {opacity:1, ease: Power2.easeOut}, 0.1, "-=0.3" )
          .staggerFromTo(cOf("p9-sub"), 0.6, {opacity:0, y:-40}, {opacity:1, y:0, ease: Power2.easeOut}, 0.1, "-=0.3")
          .fromTo(idOf("p9-hash"), 1, {width:"0px"}, {width:"293px", ease: Power2.easeOut}, "-=0.4")
        }

        function onPageLeave() {
          pg9Anim.stop();
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 9,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg10.jpg",
      "zoom": null,
      "content": `
      
      <img class="halfScale p10-title" style="top:30px; left:35px" src="/membership2019/static/_content/p10-title.png">
      <img class="halfScale p10-title" style="top:130px; left:35px" src="/membership2019/static/_content/p10-title2.png">

      <img id="" class="halfScaleC pointer pulse animatedpulse p4-icon" style="top:470px; left:42px" onclick="showOverlay('p10-pop')" src="/membership2019/static/_content/quote-marks.png">

      <img id="p10-btn" class="halfScale" style="top:614px; left:520px" src="/membership2019/static/_content/p10-refer-btn.png">

        <a href="https://www.quins.co.uk/your-club/membership/" target="_blank">
          <div class="addContentLink" style="top:613px;left:519px;width:400px;height:87px;"></div>
        </a>

        <div id="p10-pop" class="standardTransition contentOverlay hidden noclick">
          <img class="halfScale" style="top:0px;left:0px" src="/membership2019/static/_content/p10-pop-1.png">
          <img class="halfScale pointer" style="top:242px;left:720px" src="/membership2019/static/_content/cross.png" onclick="hideOverlay('p10-pop')">
        </div>
      `,
      "script": `
      
      function onPageEnter() {
        pg10Anim = new TimelineMax();
        pg10Anim.staggerFromTo(cOf("p10-title"), 0.6, {opacity:0, x:-60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.5, 0.5)
        .fromTo(idOf("p10-btn"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.4), addContentLinks}, "-=0.3" )
      }

        function onPageLeave() {
          pg10Anim.stop();
          idOf('p10-pop').className = "standardTransition contentOverlay hidden noclick"
          removeContentLinks();
        }
      
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 10,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg11.jpg",
      "zoom": null,
      "content": `
        <img class="halfScale p11-title" style="top:42px; left:35px" src="/membership2019/static/_content/p11-title.png">
        <img class="halfScale p11-title" style="top:280px; left:35px" src="/membership2019/static/_content/p11-title-2.png">
        <img class="halfScale p11-quote" style="top:42px; left:711px" src="/membership2019/static/_content/p11-quote.png">
        
        <img class="halfScale p11-play" style="top:392px; left:314px" src="/membership2019/static/_content/p11-cam.png">
        <a onclick="Publish.openVideo('https://www.youtube.com/embed/-uWmt7dB0Ug')">
          <img class="halfScaleC pointer pulse animatedpulse p11-play" style="top:400px; left:325px" src="/membership2019/static/_content/p11-play.png">
        </a>
        
        <img class="halfScale p11-banner" style="top:514px; left:0px" src="/membership2019/static/_content/p11-banner.png">
        <img class="halfScale p11-sub" style="top:578px; left:35px" src="/membership2019/static/_content/p11-sub-1.png">
        <img class="halfScale p11-sub" style="top:578px; left:366px" src="/membership2019/static/_content/p11-sub-2.png">
        <img class="halfScale p11-sub" style="top:578px; left:715px" src="/membership2019/static/_content/p11-sub-3.png">

        <img class="halfScale p11-line" style="top:574px; left:322px" src="/membership2019/static/_content/p11-line.png">
        <img class="halfScale p11-line" style="top:574px; left:665px" src="/membership2019/static/_content/p11-line.png">

        <img class="halfScale p11-look" style="top:730px; left:180px" src="/membership2019/static/_content/p11-look.png">
        <img class="halfScale p11-look" style="top:730px; left:518px" src="/membership2019/static/_content/p11-look.png">
        <img class="halfScale p11-look" style="top:730px; left:828px" src="/membership2019/static/_content/p11-look.png">

        <a href="https://hospitality.quins.co.uk/single-match/1866-lounge/" target="_blank">
          <div class="addContentLink" style="top:727px;left:177px;width:120px;height:20px;"></div>
        </a>
        <a href="https://hospitality.quins.co.uk/single-match/jason-leonard-lounge/" target="_blank">
          <div class="addContentLink" style="top:727px;left:516px;width:120px;height:20px;"></div>
        </a>
        <a href="https://hospitality.quins.co.uk/single-match/executive-boxes/" target="_blank">
          <div class="addContentLink" style="top:727px;left:827px;width:120px;height:20px;"></div>
        </a>

      `,
      "script": `
      function onPageEnter() {
        pg11Anim = new TimelineMax();
        pg11Anim.staggerFromTo(cOf("p11-title"), 0.6, {opacity:0, x:-60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.3, 1)
        .fromTo(cOf("p11-play"), 0.8, {opacity:0}, {opacity:1, ease: Power2.easeOut}, "-=0.3" )
        .fromTo(cOf("p11-banner"), 0.8, {y:400}, {y:0, ease: Power2.easeOut}, "-=0.3" )
        .staggerFromTo(cOf("p11-line"), 0.6, {opacity:0, y:60}, {opacity:1, y:0, ease: Power2.easeOut}, 0.3, "-=0.3")
        .staggerFromTo(cOf("p11-sub"), 0.6, {opacity:0, x:-60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.4, "-=0.3")
        .staggerFromTo(cOf("p11-look"), 0.6, {opacity:0, x:-30}, {opacity:1, x:0, ease: Power2.easeOut}, 0.4, "-=0.6" )
        .fromTo(cOf("p11-quote"), 0.6, {opacity:0, y:-40}, {opacity:1, y:0, ease: Power2.easeOut, onComplete: addContentLinks}, "-=0.3" )
      }

      function onPageLeave() {
        pg11Anim.stop();
        removeContentLinks();
      }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 11,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg12.jpg",
      "zoom": null,
      "content": `
      
      <!- GOLD -->
       <div class="contentLinkNone pointer" style="top: 154px; left: 399px; width: 42px; height: 81px;" onclick="showPrice('11-gold', '11-gold-close');"></div>
       <div class="contentLinkNone pointer" style="top: 154px; left: 442px; width: 42px; height: 115px;" onclick="showPrice('11-gold', '11-gold-close');"></div>
       <div class="contentLinkNone pointer" style="top: 154px; left: 485px; width: 42px; height: 81px;" onclick="showPrice('11-gold', '11-gold-close');"></div>
       <div class="contentLinkNone pointer" style="top: 644px; left: 399px; width: 42px; height: 67px;" onclick="showPrice('11-gold', '11-gold-close');"></div>
       <div class="contentLinkNone pointer" style="top: 606px; left: 442px; width: 42px; height: 105px;" onclick="showPrice('11-gold', '11-gold-close');"></div>
       <div class="contentLinkNone pointer" style="top: 644px; left: 485px; width: 42px; height: 81px;" onclick="showPrice('11-gold', '11-gold-close');"></div>

      <img id="11-gold" class="halfScale" style="top:95px;left:640px;display:none;" src="/membership2019/static/_content/p12-gold.png">
      <img id="11-gold-close" class="halfScale pointer" style="top:104px;left:808px;display:none;" src="/membership2019/static/_content/10-cross-blk.png" onclick="closePrice('11-gold', '11-gold-close')">
          

      <!- ENDGOLD -->

      <!- SILVER -->
        <div class="contentLinkNone pointer" style="top: 166px; left: 356px; width: 42px; height: 89px;" onclick="showPrice('11-silver', '11-silver-close');"></div>
       <div class="contentLinkNone pointer" style="top: 236px; left: 399px; width: 42px; height: 33px;" onclick="showPrice('11-silver', '11-silver-close');"></div>
       <div class="contentLinkNone pointer" style="top: 236px; left: 485px; width: 42px; height: 33px;" onclick="showPrice('11-silver', '11-silver-close');"></div>
       <div class="contentLinkNone pointer" style="top: 166px; left: 527px; width: 42px; height: 89px;" onclick="showPrice('11-silver', '11-silver-close');"></div>

       <div class="contentLinkNone pointer" style="top: 606px; left: 357px; width: 42px; height: 105px;" onclick="showPrice('11-silver', '11-silver-close');"></div>
       <div class="contentLinkNone pointer" style="top: 606px; left: 399px; width: 42px; height: 37px;" onclick="showPrice('11-silver', '11-silver-close');"></div>
       <div class="contentLinkNone pointer" style="top: 606px; left: 485px; width: 42px; height: 37px;" onclick="showPrice('11-silver', '11-silver-close');"></div>
       <div class="contentLinkNone pointer" style="top: 606px; left: 527px; width: 42px; height: 105px;" onclick="showPrice('11-silver', '11-silver-close');"></div>
       
          <img id="11-silver" class="halfScale" style="top:195px;left:640px;display:none;" src="/membership2019/static/_content/p12-silver.png">
          <img id="11-silver-close" class="halfScale pointer" style="top:205px;left:808px;display:none;" src="/membership2019/static/_content/10-cross-blk.png" onclick="closePrice('11-silver', '11-silver-close')">
          
        
      <!- ENDSILVER -->

      <!- BLUE -->
        <div class="contentLinkNone pointer" style="top: 149px; left: 268px; width: 42px; height: 104px;" onclick="showPrice('11-blue', '11-blue-close');"></div>
       <div class="contentLinkNone pointer" style="top: 149px; left: 314px; width: 42px; height: 104px;" onclick="showPrice('11-blue', '11-blue-close');"></div>
       <div class="contentLinkNone pointer" style="top: 149px; left: 570px; width: 42px; height: 104px;" onclick="showPrice('11-blue', '11-blue-close');"></div>
       <div class="contentLinkNone pointer" style="top: 155px; left: 613px; width: 42px; height: 100px;" onclick="showPrice('11-blue', '11-blue-close');"></div>
       
        <div class="contentLinkNone pointer" style="top: 254px; left: 356px; width: 42px; height: 23px;" onclick="showPrice('11-blue', '11-blue-close');"></div>
        <div class="contentLinkNone pointer" style="top: 269px; left: 399px; width: 42px; height: 9px;" onclick="showPrice('11-blue', '11-blue-close');"></div>
        <div class="contentLinkNone pointer" style="top: 269px; left: 484px; width: 42px; height: 9px;" onclick="showPrice('11-blue', '11-blue-close');"></div>
        <div class="contentLinkNone pointer" style="top: 254px; left: 527px; width: 42px; height: 23px;" onclick="showPrice('11-blue', '11-blue-close');"></div>

        <div class="contentLinkNone pointer" style="top: 578px; left: 357px; width: 171px; height: 28px;" onclick="showPrice('11-blue', '11-blue-close');"></div>
        <div class="contentLinkNone pointer" style="top: 585px; left: 528px; width: 42px; height: 21px;" onclick="showPrice('11-blue', '11-blue-close');"></div>


        <div class="contentLinkNone pointer" style="top: 607px; left: 233px; width: 122px; height: 104px;" onclick="showPrice('11-blue', '11-blue-close');"></div>
        <div class="contentLinkNone pointer" style="top: 607px; left: 571px; width: 122px; height: 104px;" onclick="showPrice('11-blue', '11-blue-close');"></div>

          <img id="11-blue" class="halfScale" style="top:295px;left:640px;display:none;" src="/membership2019/static/_content/p12-blue.png">
          <img id="11-blue-close" class="halfScale pointer" style="top:304px;left:808px;display:none;" src="/membership2019/static/_content/10-cross-blk.png" onclick="closePrice('11-blue', '11-blue-close')">
          
      
        <!- ENDBLUE -->

        <!- GREEN -->
        <div class="contentLinkNone pointer" style="top: 255px; left: 268px; width: 87px; height: 15px;" onclick="showPrice('11-green' , '11-green-close');"></div>
       <div class="contentLinkNone pointer" style="top: 255px; left: 570px; width: 87px; height: 15px;" onclick="showPrice('11-green', '11-green-close');"></div>
       

        <div class="contentLinkNone pointer" style="top: 348px; left: 153px; width: 104px; height: 162px;" onclick="showPrice('11-green', '11-green-close');"></div>
        <div class="contentLinkNone pointer" style="top: 368px; left: 669px; width: 110px; height: 122px;" onclick="showPrice('11-green', '11-green-close');"></div>

        <div class="contentLinkNone pointer" style="top: 592px; left: 251px; width: 106px; height: 13px;" onclick="showPrice('11-green', '11-green-close');"></div>
        <div class="contentLinkNone pointer" style="top: 592px; left: 571px; width: 106px; height: 13px;" onclick="showPrice('11-green', '11-green-close');"></div>

          <img id="11-green" class="halfScale" style="top:395px;left:640px;display:none;" src="/membership2019/static/_content/p12-green.png">
          <img id="11-green-close" class="halfScale pointer" style="top:405px;left:808px;display:none;" src="/membership2019/static/_content/10-cross-wht.png" onclick="closePrice('11-green', '11-green-close')">
          

        <!- ENDGREEN -->

        <!- PINK -->
        <div class="contentLinkNone pointer" style="top: 270px; left: 268px; width: 87px; height: 15px;" onclick="showPrice('11-pink' , '11-pink-close');"></div>
       <div class="contentLinkNone pointer" style="top: 270px; left: 570px; width: 87px; height: 15px;" onclick="showPrice('11-pink' , '11-pink-close');"></div>
       
        <div class="contentLinkNone pointer" style="top: 308px; left: 153px; width: 104px; height: 40px;" onclick="showPrice('11-pink' , '11-pink-close');"></div>
        <div class="contentLinkNone pointer" style="top: 308px; left: 669px; width: 110px; height: 61px;" onclick="showPrice('11-pink' , '11-pink-close');"></div>

        <div class="contentLinkNone pointer" style="top: 511px; left: 153px; width: 104px; height: 40px;" onclick="showPrice('11-pink' , '11-pink-close');"></div>
        <div class="contentLinkNone pointer" style="top: 488px; left: 669px; width: 110px; height: 61px;" onclick="showPrice('11-pink' , '11-pink-close');"></div>

        <div class="contentLinkNone pointer" style="top: 569px; left: 251px; width: 106px; height: 23px;" onclick="showPrice('11-pink' , '11-pink-close');"></div>
        <div class="contentLinkNone pointer" style="top: 569px; left: 571px; width: 106px; height: 23px;" onclick="showPrice('11-pink' , '11-pink-close');"></div>

          <img id="11-pink" class="halfScale" style="top:496px;left:640px; display:none;" src="/membership2019/static/_content/p12-pink.png">
          <img id="11-pink-close" class="halfScale pointer" style="top:505px;left:808px; display:none;" src="/membership2019/static/_content/10-cross-wht.png" onclick="closePrice('11-pink', '11-pink-close')">
          

        <!- ENDPINK -->

        <!- BROWN -->
        <div class="contentLinkNone pointer" style="top: 277px; left: 356px; width: 85px; height: 7px;" onclick="showPrice('11-brown' , '11-brown-close');"></div>
       <div class="contentLinkNone pointer" style="top: 277px; left: 486px; width: 85px; height: 7px;" onclick="showPrice('11-brown' , '11-brown-close');"></div>
       
        <div class="contentLinkNone pointer" style="top: 578px; left: 526px; width: 44px; height: 7px;" onclick="showPrice('11-brown' , '11-brown-close');"></div>

          <img id="11-brown" class="halfScale" style="top:596px;left:640px; display:none;" src="/membership2019/static/_content/p12-brown.png">
          <img id="11-brown-close" class="halfScale pointer" style="top:606px;left:808px; display:none;" src="/membership2019/static/_content/10-cross-wht.png" onclick="closePrice('11-brown', '11-brown-close')">
          
        <!- ENDBROWN -->

        <!- WEST -->
        <svg onclick="Publish.openGallery(['west-1.jpg', 'west-2.jpg', 'west-3.jpg', 'west-4.jpg', 'west-5.jpg', 'west-6.jpg'])" class="abs pointer pulse animatedpulse "style="left:441px;width:44px; top:358px; height:44px" viewBox="0 0 160.62 157.733" enable-background="new 0 0 160.62 157.733">
          <g>
            <path fill="#fff" d="M81.691,67.001c7.996,0,14.477,6.481,14.477,14.477s-6.481,14.477-14.477,14.477
              c-7.995,0-14.476-6.482-14.476-14.477S73.697,67.001,81.691,67.001z"/>
            <path fill="#fff" d="M124.263,52.933h-23.92l-0.716-5.581c0-3.189-2.585-5.774-5.774-5.774H69.218
              c-3.188,0-5.773,2.585-5.773,5.774l-0.716,5.581H39.001c-2.126,0-3.85,1.627-3.85,3.753v49.656c0,2.126,1.724,3.945,3.85,3.945
              h85.262c2.125,0,3.849-1.819,3.849-3.945V56.686C128.112,54.56,126.388,52.933,124.263,52.933z M81.65,105.2
              c-13.074,0-23.672-10.599-23.672-23.672S68.576,57.856,81.65,57.856s23.672,10.598,23.672,23.671S94.724,105.2,81.65,105.2z
              M123.685,63.134h-20.209v-5.966h20.209V63.134z"/>
          </g>
          <g>
            <path fill="#fff" d="M154.856,78.867h-5.764c-0.001,9.313-1.884,18.156-5.29,26.209c-5.107,12.077-13.654,22.371-24.404,29.633
              c-5.375,3.631-11.298,6.504-17.62,8.47s-13.041,3.026-20.026,3.027c-9.314-0.001-18.156-1.884-26.21-5.29
              c-12.077-5.107-22.371-13.653-29.632-24.404c-3.631-5.375-6.504-11.298-8.471-17.62c-1.966-6.322-3.026-13.041-3.026-20.026
              c0.001-9.314,1.884-18.157,5.29-26.21C24.81,40.58,33.357,30.286,44.107,23.024c5.375-3.631,11.298-6.504,17.619-8.471
              c6.322-1.966,13.041-3.026,20.027-3.026c9.313,0,18.156,1.884,26.209,5.29c12.077,5.107,22.371,13.653,29.632,24.404
              c3.631,5.375,6.504,11.298,8.471,17.619c1.966,6.322,3.026,13.041,3.026,20.027H154.856h5.764c0.001-10.874-2.207-21.262-6.2-30.7
              c-5.991-14.161-15.983-26.191-28.567-34.694c-6.292-4.251-13.235-7.62-20.649-9.926C97.791,1.241,89.907,0,81.753,0
              C70.88-0.001,60.491,2.207,51.052,6.2c-14.161,5.991-26.19,15.983-34.693,28.567c-4.251,6.292-7.62,13.235-9.926,20.648
              c-2.306,7.413-3.547,15.296-3.546,23.451c-0.001,10.873,2.207,21.262,6.2,30.7c5.991,14.161,15.983,26.191,28.567,34.694
              c6.292,4.251,13.235,7.62,20.648,9.926c7.413,2.306,15.296,3.547,23.451,3.546c10.874,0.001,21.262-2.207,30.7-6.2
              c14.161-5.991,26.191-15.984,34.694-28.568c4.251-6.292,7.621-13.235,9.926-20.648c2.306-7.413,3.547-15.296,3.547-23.45H154.856
              L154.856,78.867z"/>
          </g>
        </svg>
        <!- NORTH-->
        <svg onclick="Publish.openGallery(['north-1.jpg', 'north-2.jpg', 'north-3.jpg', 'north-4.jpg', 'north-5.jpg'])" class="abs pointer pulse animatedpulse "style="left:571px;width:44px; top:408px; height:44px" viewBox="0 0 160.62 157.733" enable-background="new 0 0 160.62 157.733">
          <g>
            <path fill="#fff" d="M81.691,67.001c7.996,0,14.477,6.481,14.477,14.477s-6.481,14.477-14.477,14.477
              c-7.995,0-14.476-6.482-14.476-14.477S73.697,67.001,81.691,67.001z"/>
            <path fill="#fff" d="M124.263,52.933h-23.92l-0.716-5.581c0-3.189-2.585-5.774-5.774-5.774H69.218
              c-3.188,0-5.773,2.585-5.773,5.774l-0.716,5.581H39.001c-2.126,0-3.85,1.627-3.85,3.753v49.656c0,2.126,1.724,3.945,3.85,3.945
              h85.262c2.125,0,3.849-1.819,3.849-3.945V56.686C128.112,54.56,126.388,52.933,124.263,52.933z M81.65,105.2
              c-13.074,0-23.672-10.599-23.672-23.672S68.576,57.856,81.65,57.856s23.672,10.598,23.672,23.671S94.724,105.2,81.65,105.2z
              M123.685,63.134h-20.209v-5.966h20.209V63.134z"/>
          </g>
          <g>
            <path fill="#fff" d="M154.856,78.867h-5.764c-0.001,9.313-1.884,18.156-5.29,26.209c-5.107,12.077-13.654,22.371-24.404,29.633
              c-5.375,3.631-11.298,6.504-17.62,8.47s-13.041,3.026-20.026,3.027c-9.314-0.001-18.156-1.884-26.21-5.29
              c-12.077-5.107-22.371-13.653-29.632-24.404c-3.631-5.375-6.504-11.298-8.471-17.62c-1.966-6.322-3.026-13.041-3.026-20.026
              c0.001-9.314,1.884-18.157,5.29-26.21C24.81,40.58,33.357,30.286,44.107,23.024c5.375-3.631,11.298-6.504,17.619-8.471
              c6.322-1.966,13.041-3.026,20.027-3.026c9.313,0,18.156,1.884,26.209,5.29c12.077,5.107,22.371,13.653,29.632,24.404
              c3.631,5.375,6.504,11.298,8.471,17.619c1.966,6.322,3.026,13.041,3.026,20.027H154.856h5.764c0.001-10.874-2.207-21.262-6.2-30.7
              c-5.991-14.161-15.983-26.191-28.567-34.694c-6.292-4.251-13.235-7.62-20.649-9.926C97.791,1.241,89.907,0,81.753,0
              C70.88-0.001,60.491,2.207,51.052,6.2c-14.161,5.991-26.19,15.983-34.693,28.567c-4.251,6.292-7.62,13.235-9.926,20.648
              c-2.306,7.413-3.547,15.296-3.546,23.451c-0.001,10.873,2.207,21.262,6.2,30.7c5.991,14.161,15.983,26.191,28.567,34.694
              c6.292,4.251,13.235,7.62,20.648,9.926c7.413,2.306,15.296,3.547,23.451,3.546c10.874,0.001,21.262-2.207,30.7-6.2
              c14.161-5.991,26.191-15.984,34.694-28.568c4.251-6.292,7.621-13.235,9.926-20.648c2.306-7.413,3.547-15.296,3.547-23.45H154.856
              L154.856,78.867z"/>
          </g>
        </svg>

        <!- DHL -->
        <svg onclick="Publish.openGallery(['dhl-1.jpg', 'dhl-2.jpg', 'dhl-3.jpg', 'dhl-4.jpg', 'dhl-5.jpg', 'dhl-6.jpg', 'dhl-7.jpg', 'dhl-8.jpg', 'dhl-9.jpg'])" class="abs pointer pulse animatedpulse "style="left:441px;width:44px; top:461px; height:44px" viewBox="0 0 160.62 157.733" enable-background="new 0 0 160.62 157.733">
          <g>
            <path fill="#fff" d="M81.691,67.001c7.996,0,14.477,6.481,14.477,14.477s-6.481,14.477-14.477,14.477
              c-7.995,0-14.476-6.482-14.476-14.477S73.697,67.001,81.691,67.001z"/>
            <path fill="#fff" d="M124.263,52.933h-23.92l-0.716-5.581c0-3.189-2.585-5.774-5.774-5.774H69.218
              c-3.188,0-5.773,2.585-5.773,5.774l-0.716,5.581H39.001c-2.126,0-3.85,1.627-3.85,3.753v49.656c0,2.126,1.724,3.945,3.85,3.945
              h85.262c2.125,0,3.849-1.819,3.849-3.945V56.686C128.112,54.56,126.388,52.933,124.263,52.933z M81.65,105.2
              c-13.074,0-23.672-10.599-23.672-23.672S68.576,57.856,81.65,57.856s23.672,10.598,23.672,23.671S94.724,105.2,81.65,105.2z
              M123.685,63.134h-20.209v-5.966h20.209V63.134z"/>
          </g>
          <g>
            <path fill="#fff" d="M154.856,78.867h-5.764c-0.001,9.313-1.884,18.156-5.29,26.209c-5.107,12.077-13.654,22.371-24.404,29.633
              c-5.375,3.631-11.298,6.504-17.62,8.47s-13.041,3.026-20.026,3.027c-9.314-0.001-18.156-1.884-26.21-5.29
              c-12.077-5.107-22.371-13.653-29.632-24.404c-3.631-5.375-6.504-11.298-8.471-17.62c-1.966-6.322-3.026-13.041-3.026-20.026
              c0.001-9.314,1.884-18.157,5.29-26.21C24.81,40.58,33.357,30.286,44.107,23.024c5.375-3.631,11.298-6.504,17.619-8.471
              c6.322-1.966,13.041-3.026,20.027-3.026c9.313,0,18.156,1.884,26.209,5.29c12.077,5.107,22.371,13.653,29.632,24.404
              c3.631,5.375,6.504,11.298,8.471,17.619c1.966,6.322,3.026,13.041,3.026,20.027H154.856h5.764c0.001-10.874-2.207-21.262-6.2-30.7
              c-5.991-14.161-15.983-26.191-28.567-34.694c-6.292-4.251-13.235-7.62-20.649-9.926C97.791,1.241,89.907,0,81.753,0
              C70.88-0.001,60.491,2.207,51.052,6.2c-14.161,5.991-26.19,15.983-34.693,28.567c-4.251,6.292-7.62,13.235-9.926,20.648
              c-2.306,7.413-3.547,15.296-3.546,23.451c-0.001,10.873,2.207,21.262,6.2,30.7c5.991,14.161,15.983,26.191,28.567,34.694
              c6.292,4.251,13.235,7.62,20.648,9.926c7.413,2.306,15.296,3.547,23.451,3.546c10.874,0.001,21.262-2.207,30.7-6.2
              c14.161-5.991,26.191-15.984,34.694-28.568c4.251-6.292,7.621-13.235,9.926-20.648c2.306-7.413,3.547-15.296,3.547-23.45H154.856
              L154.856,78.867z"/>
          </g>
        </svg>

        <!- SOUTH -->
        <svg onclick="Publish.openGallery(['south-1.jpg', 'south-2.jpg', 'south-3.jpg', 'south-4.jpg', 'south-5.jpg', 'south-6.jpg', 'south-7.jpg', 'south-8.jpg', 'south-9.jpg'])" class="abs pointer pulse animatedpulse "style="left:311px;width:44px; top:408px; height:44px" viewBox="0 0 160.62 157.733" enable-background="new 0 0 160.62 157.733">
          <g>
            <path fill="#fff" d="M81.691,67.001c7.996,0,14.477,6.481,14.477,14.477s-6.481,14.477-14.477,14.477
              c-7.995,0-14.476-6.482-14.476-14.477S73.697,67.001,81.691,67.001z"/>
            <path fill="#fff" d="M124.263,52.933h-23.92l-0.716-5.581c0-3.189-2.585-5.774-5.774-5.774H69.218
              c-3.188,0-5.773,2.585-5.773,5.774l-0.716,5.581H39.001c-2.126,0-3.85,1.627-3.85,3.753v49.656c0,2.126,1.724,3.945,3.85,3.945
              h85.262c2.125,0,3.849-1.819,3.849-3.945V56.686C128.112,54.56,126.388,52.933,124.263,52.933z M81.65,105.2
              c-13.074,0-23.672-10.599-23.672-23.672S68.576,57.856,81.65,57.856s23.672,10.598,23.672,23.671S94.724,105.2,81.65,105.2z
              M123.685,63.134h-20.209v-5.966h20.209V63.134z"/>
          </g>
          <g>
            <path fill="#fff" d="M154.856,78.867h-5.764c-0.001,9.313-1.884,18.156-5.29,26.209c-5.107,12.077-13.654,22.371-24.404,29.633
              c-5.375,3.631-11.298,6.504-17.62,8.47s-13.041,3.026-20.026,3.027c-9.314-0.001-18.156-1.884-26.21-5.29
              c-12.077-5.107-22.371-13.653-29.632-24.404c-3.631-5.375-6.504-11.298-8.471-17.62c-1.966-6.322-3.026-13.041-3.026-20.026
              c0.001-9.314,1.884-18.157,5.29-26.21C24.81,40.58,33.357,30.286,44.107,23.024c5.375-3.631,11.298-6.504,17.619-8.471
              c6.322-1.966,13.041-3.026,20.027-3.026c9.313,0,18.156,1.884,26.209,5.29c12.077,5.107,22.371,13.653,29.632,24.404
              c3.631,5.375,6.504,11.298,8.471,17.619c1.966,6.322,3.026,13.041,3.026,20.027H154.856h5.764c0.001-10.874-2.207-21.262-6.2-30.7
              c-5.991-14.161-15.983-26.191-28.567-34.694c-6.292-4.251-13.235-7.62-20.649-9.926C97.791,1.241,89.907,0,81.753,0
              C70.88-0.001,60.491,2.207,51.052,6.2c-14.161,5.991-26.19,15.983-34.693,28.567c-4.251,6.292-7.62,13.235-9.926,20.648
              c-2.306,7.413-3.547,15.296-3.546,23.451c-0.001,10.873,2.207,21.262,6.2,30.7c5.991,14.161,15.983,26.191,28.567,34.694
              c6.292,4.251,13.235,7.62,20.648,9.926c7.413,2.306,15.296,3.547,23.451,3.546c10.874,0.001,21.262-2.207,30.7-6.2
              c14.161-5.991,26.191-15.984,34.694-28.568c4.251-6.292,7.621-13.235,9.926-20.648c2.306-7.413,3.547-15.296,3.547-23.45H154.856
              L154.856,78.867z"/>
          </g>
        </svg>

        <a onclick="Publish.openVideo('https://www.youtube.com/embed/SnaB2Kl8heA')">
          <img id="" class="halfScaleC pointer pulse animatedpulse" style="top:244px; left:445px" src="/membership2019/static/_content/p4-play-button.png">
        </a>
      
      `,
      "script": `
        function onPageEnter() {
          addContentLinks()
        }

        function showPrice(ele, close) {
          var el = idOf(ele)
          var cl = idOf(close)

          el.style.display = "block";
          cl.style.display = "block";
        }

        function closePrice(ele, close) {
          var element = idOf(ele)
          var exit = idOf(close)

          element.style.display = "none";
          exit.style.display = "none";
        }

        function onPageLeave() {
          closePrice('11-gold', '11-gold-close');
          closePrice('11-silver', '11-silver-close');
          closePrice('11-blue', '11-blue-close');
          closePrice('11-green', '11-green-close');
          closePrice('11-pink', '11-pink-close');
          closePrice('11-brown', '11-brown-close');
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 12,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg13.jpg",
      "zoom": null,
      "content": `
      <img class="halfScaleC p13-btn pulse animatedpulse" style="top:38px; left:365px" src="/membership2019/static/_content/p13-box.png">

      <div class="contentLinkNone pointer" style="top: 37px; left: 362px; width: 262px; height: 35px;" onclick="showOverlay('theMatrix');"></div>

      <div id="theMatrix" class="standardTransition contentOverlay hidden noclick">
          <img class="halfScale" style="top:0px;left:246px;" src="/membership2019/static/_content/matrix.jpg">
          <img class="halfScale pointer" style="top:40px;left:950px" onclick="hideOverlay('theMatrix')" src="/membership2019/static/_content/p5-cross.png">
      </div>

      <a href="https://www.quins.co.uk/your-club/membership" target="_blank">
          <div class="addContentLink" style="top:680px;left:382px;width:220px;height:20px;"></div>
        </a>
      `,
      "script": `
        function onPageEnter() {
          addContentLinks();
        }

        function onPageLeave() {
          removeContentLinks();
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 13,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg14.jpg",
      "zoom": null,
      "content": `
      
      <img class="halfScale p14-title"  style="top:32px; left:40px" src="/membership2019/static/_content/p14-title.png">

      <img class="halfScale p14-quote" id="p14-quote"  style="top:268px; left:300px" src="/membership2019/static/_content/p14-quote.png">
      

      <div id="14-coyq" class="abs noOverflow" style="top:591px;left:297px;height:133px;width:293px">
        <img class="halfScale" src="/membership2019/static/_content/p14-coyq.png">
      </div>

      <div class="addContentLink" style="top:430px;left:33px;height:16px;width:190px;">
        <a href="https://www.quins.co.uk/your-club/membership/" target="_blank"></a>
      </div>
       
       
      `,
      "script": `

        function onPageEnter() {
          pg12Anim = new TimelineMax();
          pg12Anim.fromTo(cOf("p14-title"), 0.6, {opacity:0, x:-60}, {opacity:1, x:0, ease: Power2.easeOut}, 1)
          .fromTo(idOf("p14-quote"), 0.8, {opacity:0, x:-60}, {opacity:1, x:0, ease: Power2.easeOut}, "-=0.2" )
          .fromTo(idOf("14-coyq"), 0.8, {width:"0px"}, {width:"293px", ease: Power2.easeOut, onComplete: addContentLinks}, "-=0.2")
        }

        function onPageLeave() {
          pg12Anim.stop();
          removeContentLinks();
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 14,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg15.jpg",
      "zoom": null,
      "content": `
      
      <img class="halfScale p15-title" style="top:32px; left:30px" src="/membership2019/static/_content/p15-title.png">
      <img class="halfScale p15-sub" style="top:512px; left:30px" src="/membership2019/static/_content/p15-sub-1.png">
      <img class="halfScale p15-img" style="top:511px; left:30px" src="/membership2019/static/_content/p15-img.jpg">

      <div class="addContentLink" style="top:659px;left:571px;height:16px;width:143px;">
        <a href="https://tickets.quins.co.uk" target="_blank"></a>
      </div>
      
      `,
      "script": `

        function onPageEnter() {
          pg15Anim = new TimelineMax();
          pg15Anim.fromTo(cOf("p15-title"), 0.6, {opacity:0, x:-60}, {opacity:1, x:0, ease: Power2.easeOut}, 1)
          .fromTo(cOf("p15-img"), 0.6, {opacity:0}, {opacity:1, ease: Power2.easeOut}, "-=0.3")
          .fromTo(cOf("p15-sub"), 0.6, {opacity:0}, {opacity:1, ease: Power2.easeOut, addContentLinks}, "-=0.3")
        }

        function onPageLeave() {
          pg15Anim.stop();
          removeContentLinks();
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 15,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg16.jpg",
      "zoom": null,
      "content": `
      
      <img class="halfScale p16-title" style="top:40px; left:30px" src="/membership2019/static/_content/p16-title.png">
      <img class="halfScale p16-title" style="top:173px; left:573px" src="/membership2019/static/_content/p16-sub-1.png">
      <img class="halfScale p16-title" style="top:609px; left:693px" src="/membership2019/static/_content/p16-sub-2.png">
      <img class="halfScaleC p16-img" style="top:-65px; left:723px" src="/membership2019/static/_content/p16-img.jpg">
      `,
      "script": `

        function onPageEnter() {
          pg16Anim = new TimelineMax();
          pg16Anim.staggerFromTo(cOf("p16-title"), 0.6, {opacity:0, x:-60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.3, 1)
          .fromTo(cOf("p16-img"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.4)}, "-=1.2" )
        }

        function onPageLeave() {
          pg16Anim.stop();
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 16,
      "subIndex": 0,
      "startIndex": 0,
      "original": "campaign-page.jpg",
      "zoom": null,
      "content": `

      <img id="campaign-title" class="halfScale" style="top:33px; left:38px" src="/membership2019/static/_content/campaign-title.png">

      <a onclick="Publish.openVideo('https://www.youtube.com/embed/sVDR-ug44wE')">
        <img id="campaign-image" class="halfScale" style="top:247px; left:137px" src="/membership2019/static/_content/campaign-image.png">
      </a>
      <a href="https://tickets.quins.co.uk/PagesPublic/UserControlled/UserDefined.aspx?page=Memberships" target="_blank">
        <img class="halfScale" style="top:693px; left:418px" src="/membership2019/static/_content/17-box.jpg">
      </a>
      `,
      "script": `
      function onPageEnter() {
        pg17Anim = new TimelineMax();
        pg17Anim.fromTo(idOf("campaign-title"), 0.6, {opacity:0, x:-60}, {opacity:1, x:0, ease: Power2.easeOut}, 1 )
        
      }

        function onPageLeave() {
          pg17Anim.stop();
        }
      `,
      "searchText": ""
    }]],
    "script": `
      function idOf(id) {
        return document.getElementById(id)
      }
  
      function cOf(klass) {
        return document.getElementsByClassName(klass)
      }
      
      function removeContentLinks() {
        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))
        contentLinks.map(function callback(e) { 
          return e.className = 'addContentLink'
        })
      }
  
      function addContentLinks() {
        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))
        contentLinks.map(function callback(e) {
          return e.className = 'contentLink addContentLink'
        })
      }

      function flashContentLinksThreeTimes() {
        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))
        contentLinks.map(function callback(e) {
          return e.className = 'contentLinkThree addContentLink'
        })
      }
  
      function showOverlay(idx) {
        idOf(idx).className = 'contentOverlay visible'
      }
  
      function hideOverlay(idx) {
        idOf(idx).className = 'contentOverlay hidden noclick'
      }

      function animateNumber(element){
        if(element.getAttribute("data-number")){
          var args = JSON.parse(element.getAttribute("data-number"));
          var from = 0;
          var to = 100;
          var append = "";
          var preppend = "";
          var decimals = 0;
          var duration = 1;
          var ease = "Linear.easeNone";
          var comma = false;
          var separator = ",";
          var decChar = ".";
          for(obj in args){
            if(obj == "from") from = args[obj];
            if(obj == "to") to = args[obj];
            if(obj == "append") append = args[obj];
            if(obj == "preppend") preppend = args[obj];
            if(obj == "decimals") decimals = args[obj];
            if(obj == "duration") duration = args[obj];
            if(obj == "ease") ease = args[obj];
            if(obj == "comma") comma = args[obj];
            if(obj == "separator") separator = args[obj];
            if(obj == "decChar") decChar = args[obj];
          }
          var obj = {number: from}
          TweenMax.to(obj, duration, {number: to, onUpdate: function(){
            if(comma){
              console.log(obj.number)
              var str = obj.number.toFixed(decimals).toString();
              var predec = str.split(/^\d*/)[0];
              console.log("PREDEC", predec, typeof(predec));
              var newstr = predec.split('').reverse().join('').replace(/(.{3})/g, '$1'+ separator).split('').reverse().join('')
              var comp = newstr.replace(/^,/, '')
              console.log("NEWSTR", newstr, typeof(newstr));
              // console.log({newstr})
              // var dp = str.split(/\.\d+/) ? str.split(/\.\d+/)[0] : "";
              // if(dp[0]) dp = dp[0].replace(".", decChar);
              var dp = "";
              element.innerHTML = preppend+comp+dp+append;
            }else{
              element.innerHTML = preppend+obj.number.toFixed(decimals).toString().replace(".", decChar)+append;
            }
          }, ease: eval(ease)});
        }else{
          return;
        }
      }

      function resetNumbers(ele){
        var numbers = cOf(ele)
        for(var i=0; i<numbers.length; i++) {
          numbers[i].innerText= ""
        }
      }

      function individualGallery(index) {
        Publish.openGalleryTwo([['', ''], index])
      }
    `,
    "mobilePages": null,
    "mobileTemplate": null,
  }


// WEBPACK FOOTER //
// ./src/document.js